import { Avatar } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/';

const useStyles = makeStyles((theme) => ({
	small: {
		width: theme.spacing(7),
		height: theme.spacing(7),
		marginLeft: '1px',
	},
	productLabel: {
		marginLeft: '3px',
	},
}));

function ProductWithThumbnail({ url, productName }) {
	const classes = useStyles();
	return (
		<React.Fragment>
			<Avatar className={classes.small} alt="" variant="square" sizes="" src={url}></Avatar>
			<span className={classes.productLabel}>{productName}</span>
		</React.Fragment>
	);
}

export default ProductWithThumbnail;
